import { render, staticRenderFns } from "./SfTab.vue?vue&type=template&id=5d76a7ee&"
import script from "./SfTab.vue?vue&type=script&lang=ts&"
export * from "./SfTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports